module.exports = __webpack_public_path__ + "static/media/my_family_doctor_p1_2.33626f1e.png";